export const getCookieValue = a => {
  const b = document.cookie.match(`(^|;)\\s*${a}\\s*=\\s*([^;]+)`);
  return b ? b.pop() : '';
};

export const setCookie = (name, value = '', expires = 30) => {
  const expireDate = new Date(
    new Date().getTime() + expires * 1000 * 60 * 60 * 24,
  );
  document.cookie = `${name}=${escape(
    value,
  )};expires=${expireDate.toGMTString()};path=/`;
};

export const clearCookie = name => {
  const expireDate = new Date(new Date().getTime() - 1000 * 60 * 60 * 24);
  document.cookie = `${name}=;expires=${expireDate.toGMTString()};path=/`;
};
